export type Maybe<T> =
	T
	| null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {
	[key: string]: unknown
}> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> =
	Omit<T, K>
	& { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> =
	Omit<T, K>
	& { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends {
	[key: string]: unknown
}, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> =
	T
	| { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: {
		input: string;
		output: string;
	}
	String: {
		input: string;
		output: string;
	}
	Boolean: {
		input: boolean;
		output: boolean;
	}
	Int: {
		input: number;
		output: number;
	}
	Float: {
		input: number;
		output: number;
	}
	ISO8601Date: {
		input: any;
		output: any;
	}
	ISO8601DateTime: {
		input: any;
		output: any;
	}
};

export type ActiveRecordModel = {
	createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
	id?: Maybe<Scalars['ID']['output']>;
	updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type AppsAndWebsites = {
	__typename?: 'AppsAndWebsites';
	appName?: Maybe<Scalars['String']['output']>;
	id: Scalars['String']['output'];
	keywords?: Maybe<Array<Scalars['String']['output']>>;
	source: Scalars['String']['output'];
	timeCategory: Category;
	timeSpent: Scalars['Int']['output'];
	title: Scalars['String']['output'];
	trueTimeCategory: Category;
	type: Scalars['String']['output'];
	url?: Maybe<Scalars['String']['output']>;
	urlHost?: Maybe<Scalars['String']['output']>;
};

export type BudgetInterval = {
	__typename?: 'BudgetInterval';
	budgetIntervalEndTime: Scalars['ISO8601DateTime']['output'];
	budgetIntervalStartTime: Scalars['ISO8601DateTime']['output'];
	timeBudget: Scalars['Int']['output'];
	timeBudgetInterval: Scalars['String']['output'];
	timeSpent: Scalars['Int']['output'];
};

export type Category = {
	__typename?: 'Category';
	focus: Scalars['Boolean']['output'];
	idle: Scalars['Boolean']['output'];
	key: Scalars['String']['output'];
	name: Scalars['String']['output'];
	work: Scalars['Boolean']['output'];
};

export type CategoryTimeSpent = {
	__typename?: 'CategoryTimeSpent';
	category: Category;
	timeSpent: Scalars['Int']['output'];
};

export type Client =
	ActiveRecordModel
	& {
		__typename?: 'Client';
		color: Scalars['String']['output'];
		createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
		currentTimeBudget?: Maybe<BudgetInterval>;
		defaultFlag?: Maybe<Scalars['Boolean']['output']>;
		emoji?: Maybe<Scalars['String']['output']>;
		hourlyRate?: Maybe<Scalars['Float']['output']>;
		id?: Maybe<Scalars['ID']['output']>;
		keywords: Array<Scalars['String']['output']>;
		lastUsedAt: Scalars['ISO8601DateTime']['output'];
		name: Scalars['String']['output'];
		status: Scalars['String']['output'];
		timeBudget?: Maybe<Scalars['Int']['output']>;
		timeBudgetInterval?: Maybe<Scalars['String']['output']>;
		timeSpent: Scalars['Int']['output'];
		timeSpentWithoutChildren: Scalars['Int']['output'];
		totalTimeSpent: Scalars['Int']['output'];
		updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
	};


export type ClientTimeSpentArgs = {
	endTime: Scalars['ISO8601DateTime']['input'];
	startTime: Scalars['ISO8601DateTime']['input'];
};


export type ClientTimeSpentWithoutChildrenArgs = {
	endTime: Scalars['ISO8601DateTime']['input'];
	startTime: Scalars['ISO8601DateTime']['input'];
};

/** The connection type for Client. */
export type ClientConnection = {
	__typename?: 'ClientConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ClientEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Client>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ClientEdge = {
	__typename?: 'ClientEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String']['output'];
	/** The item at the end of the edge. */
	node?: Maybe<Client>;
};

export type ClientInput = {
	color?: InputMaybe<Scalars['String']['input']>;
	emoji?: InputMaybe<Scalars['String']['input']>;
	hourlyRate?: InputMaybe<Scalars['Float']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	keywords?: InputMaybe<Array<Scalars['String']['input']>>;
	name?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<Scalars['String']['input']>;
	timeBudget?: InputMaybe<Scalars['Int']['input']>;
	timeBudgetInterval?: InputMaybe<Scalars['String']['input']>;
};

export type ClientTimeEntry =
	ActiveRecordModel
	& {
		__typename?: 'ClientTimeEntry';
		client: Client;
		createdAt: Scalars['ISO8601DateTime']['output'];
		duration: Scalars['Int']['output'];
		endTime: Scalars['ISO8601DateTime']['output'];
		id?: Maybe<Scalars['ID']['output']>;
		source: Scalars['String']['output'];
		startTime: Scalars['ISO8601DateTime']['output'];
		updatedAt: Scalars['ISO8601DateTime']['output'];
	};

/** Autogenerated input type of CreateClient */
export type CreateClientInput = {
	args: ClientInput;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateClient */
export type CreateClientPayload = {
	__typename?: 'CreateClientPayload';
	client: Client;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
};

/** Autogenerated input type of CreateClientTimeEntry */
export type CreateClientTimeEntryInput = {
	clientId: Scalars['ID']['input'];
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	endTime: Scalars['ISO8601DateTime']['input'];
	startTime: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of CreateClientTimeEntry */
export type CreateClientTimeEntryPayload = {
	__typename?: 'CreateClientTimeEntryPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	timeEntry: ClientTimeEntry;
};

/** Autogenerated input type of CreateProject */
export type CreateProjectInput = {
	args: ProjectInput;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateProject */
export type CreateProjectPayload = {
	__typename?: 'CreateProjectPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	project: Project;
};

/** Autogenerated input type of CreateProjectTimeEntry */
export type CreateProjectTimeEntryInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	endTime: Scalars['ISO8601DateTime']['input'];
	projectId: Scalars['ID']['input'];
	startTime: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of CreateProjectTimeEntry */
export type CreateProjectTimeEntryPayload = {
	__typename?: 'CreateProjectTimeEntryPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	timeEntry: ProjectTimeEntry;
};

/** Autogenerated input type of CreateSession */
export type CreateSessionInput = {
	args: SessionInput;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSession */
export type CreateSessionPayload = {
	__typename?: 'CreateSessionPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	session?: Maybe<Session>;
};

/** Autogenerated input type of CreateTask */
export type CreateTaskInput = {
	args: TaskInput;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateTask */
export type CreateTaskPayload = {
	__typename?: 'CreateTaskPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	task: Task;
};

/** Autogenerated input type of CreateTaskTimeEntry */
export type CreateTaskTimeEntryInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
	description?: InputMaybe<Scalars['String']['input']>;
	endTime: Scalars['ISO8601DateTime']['input'];
	startTime: Scalars['ISO8601DateTime']['input'];
	taskId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateTaskTimeEntry */
export type CreateTaskTimeEntryPayload = {
	__typename?: 'CreateTaskTimeEntryPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	timeEntry: TaskTimeEntry;
};

/** Autogenerated input type of DeleteClient */
export type DeleteClientInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteClient */
export type DeleteClientPayload = {
	__typename?: 'DeleteClientPayload';
	client: Client;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
};

/** Autogenerated input type of DeleteClientTimeEntry */
export type DeleteClientTimeEntryInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteClientTimeEntry */
export type DeleteClientTimeEntryPayload = {
	__typename?: 'DeleteClientTimeEntryPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	timeEntry: ClientTimeEntry;
};

/** Autogenerated input type of DeleteProject */
export type DeleteProjectInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProject */
export type DeleteProjectPayload = {
	__typename?: 'DeleteProjectPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	project: Project;
};

/** Autogenerated input type of DeleteProjectTimeEntry */
export type DeleteProjectTimeEntryInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProjectTimeEntry */
export type DeleteProjectTimeEntryPayload = {
	__typename?: 'DeleteProjectTimeEntryPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	timeEntry: ProjectTimeEntry;
};

/** Autogenerated input type of DeleteSession */
export type DeleteSessionInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteSession */
export type DeleteSessionPayload = {
	__typename?: 'DeleteSessionPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	session?: Maybe<Session>;
};

/** Autogenerated input type of DeleteTask */
export type DeleteTaskInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteTask */
export type DeleteTaskPayload = {
	__typename?: 'DeleteTaskPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	task: Task;
};

/** Autogenerated input type of DeleteTaskTimeEntry */
export type DeleteTaskTimeEntryInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
	id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteTaskTimeEntry */
export type DeleteTaskTimeEntryPayload = {
	__typename?: 'DeleteTaskTimeEntryPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	timeEntry: TaskTimeEntry;
};

/** Autogenerated input type of ExtendCurrentSession */
export type ExtendCurrentSessionInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
	length: Scalars['Int']['input'];
};

/** Autogenerated return type of ExtendCurrentSession */
export type ExtendCurrentSessionPayload = {
	__typename?: 'ExtendCurrentSessionPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	session?: Maybe<Session>;
};

export type Mutation = {
	__typename?: 'Mutation';
	createClient?: Maybe<CreateClientPayload>;
	createClientTimeEntry?: Maybe<CreateClientTimeEntryPayload>;
	createProject?: Maybe<CreateProjectPayload>;
	createProjectTimeEntry?: Maybe<CreateProjectTimeEntryPayload>;
	createSession?: Maybe<CreateSessionPayload>;
	createTask?: Maybe<CreateTaskPayload>;
	createTaskTimeEntry?: Maybe<CreateTaskTimeEntryPayload>;
	deleteClient?: Maybe<DeleteClientPayload>;
	deleteClientTimeEntry?: Maybe<DeleteClientTimeEntryPayload>;
	deleteProject?: Maybe<DeleteProjectPayload>;
	deleteProjectTimeEntry?: Maybe<DeleteProjectTimeEntryPayload>;
	deleteSession?: Maybe<DeleteSessionPayload>;
	deleteTask?: Maybe<DeleteTaskPayload>;
	deleteTaskTimeEntry?: Maybe<DeleteTaskTimeEntryPayload>;
	extendCurrentSession?: Maybe<ExtendCurrentSessionPayload>;
	startSessionTimer?: Maybe<StartSessionTimerPayload>;
	stopSessionTimer?: Maybe<StopSessionTimerPayload>;
	updateClient?: Maybe<UpdateClientPayload>;
	updateClientTimeEntry?: Maybe<UpdateClientTimeEntryPayload>;
	updateProject?: Maybe<UpdateProjectPayload>;
	updateProjectTimeEntry?: Maybe<UpdateProjectTimeEntryPayload>;
	updateSession?: Maybe<UpdateSessionPayload>;
	updateTask?: Maybe<UpdateTaskPayload>;
	updateTaskTimeEntry?: Maybe<UpdateTaskTimeEntryPayload>;
};


export type MutationCreateClientArgs = {
	input: CreateClientInput;
};


export type MutationCreateClientTimeEntryArgs = {
	input: CreateClientTimeEntryInput;
};


export type MutationCreateProjectArgs = {
	input: CreateProjectInput;
};


export type MutationCreateProjectTimeEntryArgs = {
	input: CreateProjectTimeEntryInput;
};


export type MutationCreateSessionArgs = {
	input: CreateSessionInput;
};


export type MutationCreateTaskArgs = {
	input: CreateTaskInput;
};


export type MutationCreateTaskTimeEntryArgs = {
	input: CreateTaskTimeEntryInput;
};


export type MutationDeleteClientArgs = {
	input: DeleteClientInput;
};


export type MutationDeleteClientTimeEntryArgs = {
	input: DeleteClientTimeEntryInput;
};


export type MutationDeleteProjectArgs = {
	input: DeleteProjectInput;
};


export type MutationDeleteProjectTimeEntryArgs = {
	input: DeleteProjectTimeEntryInput;
};


export type MutationDeleteSessionArgs = {
	input: DeleteSessionInput;
};


export type MutationDeleteTaskArgs = {
	input: DeleteTaskInput;
};


export type MutationDeleteTaskTimeEntryArgs = {
	input: DeleteTaskTimeEntryInput;
};


export type MutationExtendCurrentSessionArgs = {
	input: ExtendCurrentSessionInput;
};


export type MutationStartSessionTimerArgs = {
	input: StartSessionTimerInput;
};


export type MutationStopSessionTimerArgs = {
	input: StopSessionTimerInput;
};


export type MutationUpdateClientArgs = {
	input: UpdateClientInput;
};


export type MutationUpdateClientTimeEntryArgs = {
	input: UpdateClientTimeEntryInput;
};


export type MutationUpdateProjectArgs = {
	input: UpdateProjectInput;
};


export type MutationUpdateProjectTimeEntryArgs = {
	input: UpdateProjectTimeEntryInput;
};


export type MutationUpdateSessionArgs = {
	input: UpdateSessionInput;
};


export type MutationUpdateTaskArgs = {
	input: UpdateTaskInput;
};


export type MutationUpdateTaskTimeEntryArgs = {
	input: UpdateTaskTimeEntryInput;
};

/** Information about pagination in a connection. */
export type PageInfo = {
	__typename?: 'PageInfo';
	/** When paginating forwards, the cursor to continue. */
	endCursor?: Maybe<Scalars['String']['output']>;
	/** When paginating forwards, are there more items? */
	hasNextPage: Scalars['Boolean']['output'];
	/** When paginating backwards, are there more items? */
	hasPreviousPage: Scalars['Boolean']['output'];
	/** When paginating backwards, the cursor to continue. */
	startCursor?: Maybe<Scalars['String']['output']>;
};

export type Project =
	ActiveRecordModel
	& {
		__typename?: 'Project';
		client?: Maybe<Client>;
		color: Scalars['String']['output'];
		createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
		currentTimeBudget?: Maybe<BudgetInterval>;
		defaultFlag?: Maybe<Scalars['Boolean']['output']>;
		emoji?: Maybe<Scalars['String']['output']>;
		id?: Maybe<Scalars['ID']['output']>;
		keywords: Array<Scalars['String']['output']>;
		lastUsedAt: Scalars['ISO8601DateTime']['output'];
		name: Scalars['String']['output'];
		status: Scalars['String']['output'];
		timeBudget?: Maybe<Scalars['Int']['output']>;
		timeBudgetInterval?: Maybe<Scalars['String']['output']>;
		timeSpent: Scalars['Int']['output'];
		timeSpentWithoutChildren: Scalars['Int']['output'];
		totalTimeSpent: Scalars['Int']['output'];
		updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
	};


export type ProjectTimeSpentArgs = {
	endTime: Scalars['ISO8601DateTime']['input'];
	startTime: Scalars['ISO8601DateTime']['input'];
};


export type ProjectTimeSpentWithoutChildrenArgs = {
	endTime: Scalars['ISO8601DateTime']['input'];
	startTime: Scalars['ISO8601DateTime']['input'];
};

/** The connection type for Project. */
export type ProjectConnection = {
	__typename?: 'ProjectConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<ProjectEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Project>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProjectEdge = {
	__typename?: 'ProjectEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String']['output'];
	/** The item at the end of the edge. */
	node?: Maybe<Project>;
};

export type ProjectInput = {
	color?: InputMaybe<Scalars['String']['input']>;
	emoji?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	keywords?: InputMaybe<Array<Scalars['String']['input']>>;
	name?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<Scalars['String']['input']>;
	timeBudget?: InputMaybe<Scalars['Int']['input']>;
	timeBudgetInterval?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectTimeEntry =
	ActiveRecordModel
	& {
		__typename?: 'ProjectTimeEntry';
		createdAt: Scalars['ISO8601DateTime']['output'];
		duration: Scalars['Int']['output'];
		endTime: Scalars['ISO8601DateTime']['output'];
		id?: Maybe<Scalars['ID']['output']>;
		project: Project;
		source: Scalars['String']['output'];
		startTime: Scalars['ISO8601DateTime']['output'];
		updatedAt: Scalars['ISO8601DateTime']['output'];
	};

export type Query = {
	__typename?: 'Query';
	/** Returns apps and websites for a specific time range */
	appsAndWebsites: Array<AppsAndWebsites>;
	/** Returns categories by time breakdown */
	categories: Array<CategoryTimeSpent>;
	/** Returns the client of the current user for a client ID */
	client?: Maybe<Client>;
	/** Returns client time entries of the current user for a given time range */
	clientTimeEntries: Array<ClientTimeEntry>;
	/** Returns the time_entry of the current user for a time_entry ID */
	clientTimeEntry?: Maybe<ClientTimeEntry>;
	/** Returns all the clients of the current user */
	clients: ClientConnection;
	/** Returns the current session of the current user */
	currentSession?: Maybe<Session>;
	/** Returns authenticated user */
	currentUser: User;
	/** Returns the project of the current user for a project ID */
	project?: Maybe<Project>;
	/** Returns project time entries of the current user for a given time range */
	projectTimeEntries: Array<ProjectTimeEntry>;
	/** Returns the time_entry of the current user for a time_entry ID */
	projectTimeEntry?: Maybe<ProjectTimeEntry>;
	/** Returns all the projects of the current user */
	projects: ProjectConnection;
	/** Returns all the sessions of the current user */
	sessions: Array<Session>;
	/** Returns the stat summaries for a given date range */
	summaries: Summary;
	/** Returns the task of the current user for a task ID */
	task?: Maybe<Task>;
	/** Returns task time entries of the current user for a given time range */
	taskTimeEntries: Array<TaskTimeEntry>;
	/** Returns the time_entry of the current user for a time_entry ID */
	taskTimeEntry?: Maybe<TaskTimeEntry>;
	/** Returns all the tasks of the current user */
	tasks: TaskConnection;
};


export type QueryAppsAndWebsitesArgs = {
	endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
	startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QueryCategoriesArgs = {
	endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
	startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};


export type QueryClientArgs = {
	id: Scalars['ID']['input'];
};


export type QueryClientTimeEntriesArgs = {
	endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
	sort?: InputMaybe<TimeEntrySortEnum>;
	startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
	statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryClientTimeEntryArgs = {
	id: Scalars['ID']['input'];
};


export type QueryClientsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	defaultFlag?: InputMaybe<Scalars['Boolean']['input']>;
	first?: InputMaybe<Scalars['Int']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	query?: InputMaybe<Scalars['String']['input']>;
	sort?: InputMaybe<SortEnum>;
	statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryProjectArgs = {
	id: Scalars['ID']['input'];
};


export type QueryProjectTimeEntriesArgs = {
	endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
	sort?: InputMaybe<TimeEntrySortEnum>;
	startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
	statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryProjectTimeEntryArgs = {
	id: Scalars['ID']['input'];
};


export type QueryProjectsArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	defaultFlag?: InputMaybe<Scalars['Boolean']['input']>;
	first?: InputMaybe<Scalars['Int']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	query?: InputMaybe<Scalars['String']['input']>;
	sort?: InputMaybe<SortEnum>;
	statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QuerySessionsArgs = {
	endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
	sort?: InputMaybe<TimeEntrySortEnum>;
	startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
	statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QuerySummariesArgs = {
	bucketSize: Scalars['String']['input'];
	endDate: Scalars['ISO8601Date']['input'];
	includeCategories?: InputMaybe<Scalars['Boolean']['input']>;
	startDate: Scalars['ISO8601Date']['input'];
};


export type QueryTaskArgs = {
	id: Scalars['ID']['input'];
};


export type QueryTaskTimeEntriesArgs = {
	endTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
	sort?: InputMaybe<TimeEntrySortEnum>;
	startTime?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
	statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryTaskTimeEntryArgs = {
	id: Scalars['ID']['input'];
};


export type QueryTasksArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	defaultFlag?: InputMaybe<Scalars['Boolean']['input']>;
	first?: InputMaybe<Scalars['Int']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	query?: InputMaybe<Scalars['String']['input']>;
	sort?: InputMaybe<SortEnum>;
	statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Session =
	ActiveRecordModel
	& {
		__typename?: 'Session';
		clients: Array<Client>;
		createdAt: Scalars['ISO8601DateTime']['output'];
		description?: Maybe<Scalars['String']['output']>;
		endTime: Scalars['ISO8601DateTime']['output'];
		id?: Maybe<Scalars['ID']['output']>;
		projects: Array<Project>;
		source: Scalars['String']['output'];
		startTime: Scalars['ISO8601DateTime']['output'];
		tasks: Array<Task>;
		title?: Maybe<Scalars['String']['output']>;
		type: Scalars['String']['output'];
		updatedAt: Scalars['ISO8601DateTime']['output'];
	};

export type SessionInput = {
	description?: InputMaybe<Scalars['String']['input']>;
	endTime: Scalars['ISO8601DateTime']['input'];
	id?: InputMaybe<Scalars['String']['input']>;
	source?: InputMaybe<Scalars['String']['input']>;
	startTime: Scalars['ISO8601DateTime']['input'];
	title?: InputMaybe<Scalars['String']['input']>;
	type?: InputMaybe<SessionTypeEnum>;
};

export enum SessionTypeEnum {
	/** Break Session */
	Break   = 'break',
	/** Custom Session */
	Custom  = 'custom',
	/** Focus Session */
	Focus   = 'focus',
	/** Meeting Session */
	Meeting = 'meeting',
	/** Other Type of Session */
	Other   = 'other'
}

export enum SortEnum {
	/** Sort by descending created_at */
	CreatedAt  = 'created_at',
	/** Sort by descending last_used_at */
	LastUsedAt = 'last_used_at',
	/** Sort by descending updated_at */
	UpdatedAt  = 'updated_at'
}

/** Autogenerated input type of StartSessionTimer */
export type StartSessionTimerInput = {
	clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
	intention?: InputMaybe<Scalars['String']['input']>;
	length?: InputMaybe<Scalars['Int']['input']>;
	projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	taskIds?: InputMaybe<Array<Scalars['ID']['input']>>;
	title?: InputMaybe<Scalars['String']['input']>;
	type: Scalars['String']['input'];
};

/** Autogenerated return type of StartSessionTimer */
export type StartSessionTimerPayload = {
	__typename?: 'StartSessionTimerPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	session: Session;
};

/** Autogenerated input type of StopSessionTimer */
export type StopSessionTimerInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of StopSessionTimer */
export type StopSessionTimerPayload = {
	__typename?: 'StopSessionTimerPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	session?: Maybe<Session>;
};

export type Summary = {
	__typename?: 'Summary';
	breakTime: Scalars['Int']['output'];
	breakTimeAverage: Scalars['Float']['output'];
	bucketSize: Scalars['String']['output'];
	buckets: Array<SummaryBucket>;
	categories: Array<SummaryCategory>;
	endTime: Scalars['ISO8601DateTime']['output'];
	focusTime: Scalars['Int']['output'];
	focusTimeAverage: Scalars['Float']['output'];
	meetingTime: Scalars['Int']['output'];
	meetingTimeAverage: Scalars['Float']['output'];
	startTime: Scalars['ISO8601DateTime']['output'];
	trackedTime: Scalars['Int']['output'];
	trackedTimeAverage: Scalars['Float']['output'];
	workHours: Scalars['Int']['output'];
	workHoursAverage: Scalars['Float']['output'];
	workHoursTarget?: Maybe<Scalars['Int']['output']>;
	workHoursThreshold?: Maybe<Scalars['Int']['output']>;
};

export type SummaryBucket = {
	__typename?: 'SummaryBucket';
	breakTime: Scalars['Int']['output'];
	categories: Array<SummaryCategory>;
	dailyBreakTimeAverage: Scalars['Float']['output'];
	dailyFocusTimeAverage: Scalars['Float']['output'];
	dailyMeetingTimeAverage: Scalars['Float']['output'];
	dailyTrackedTimeAverage: Scalars['Float']['output'];
	dailyWorkHoursAverage: Scalars['Float']['output'];
	date: Scalars['String']['output'];
	endTime: Scalars['ISO8601DateTime']['output'];
	focusTime: Scalars['Int']['output'];
	meetingTime: Scalars['Int']['output'];
	pto: Scalars['Boolean']['output'];
	startTime: Scalars['ISO8601DateTime']['output'];
	trackedTime: Scalars['Int']['output'];
	wday: Scalars['String']['output'];
	workHours: Scalars['Int']['output'];
	workHoursTarget?: Maybe<Scalars['Int']['output']>;
	workHoursThreshold?: Maybe<Scalars['Int']['output']>;
};

export type SummaryCategory = {
	__typename?: 'SummaryCategory';
	category: Category;
	timeSpent: Scalars['Int']['output'];
};

export type Task =
	ActiveRecordModel
	& {
		__typename?: 'Task';
		color: Scalars['String']['output'];
		createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
		currentTimeBudget?: Maybe<BudgetInterval>;
		defaultFlag?: Maybe<Scalars['Boolean']['output']>;
		emoji?: Maybe<Scalars['String']['output']>;
		id?: Maybe<Scalars['ID']['output']>;
		keywords: Array<Scalars['String']['output']>;
		lastUsedAt: Scalars['ISO8601DateTime']['output'];
		name: Scalars['String']['output'];
		project?: Maybe<Project>;
		status: Scalars['String']['output'];
		timeBudget?: Maybe<Scalars['Int']['output']>;
		timeBudgetInterval?: Maybe<Scalars['String']['output']>;
		timeSpent: Scalars['Int']['output'];
		timeSpentWithoutChildren: Scalars['Int']['output'];
		totalTimeSpent: Scalars['Int']['output'];
		updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
	};


export type TaskTimeSpentArgs = {
	endTime: Scalars['ISO8601DateTime']['input'];
	startTime: Scalars['ISO8601DateTime']['input'];
};


export type TaskTimeSpentWithoutChildrenArgs = {
	endTime: Scalars['ISO8601DateTime']['input'];
	startTime: Scalars['ISO8601DateTime']['input'];
};

/** The connection type for Task. */
export type TaskConnection = {
	__typename?: 'TaskConnection';
	/** A list of edges. */
	edges?: Maybe<Array<Maybe<TaskEdge>>>;
	/** A list of nodes. */
	nodes?: Maybe<Array<Maybe<Task>>>;
	/** Information to aid in pagination. */
	pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TaskEdge = {
	__typename?: 'TaskEdge';
	/** A cursor for use in pagination. */
	cursor: Scalars['String']['output'];
	/** The item at the end of the edge. */
	node?: Maybe<Task>;
};

export type TaskInput = {
	color?: InputMaybe<Scalars['String']['input']>;
	emoji?: InputMaybe<Scalars['String']['input']>;
	id?: InputMaybe<Scalars['ID']['input']>;
	keywords?: InputMaybe<Array<Scalars['String']['input']>>;
	name?: InputMaybe<Scalars['String']['input']>;
	status?: InputMaybe<Scalars['String']['input']>;
	timeBudget?: InputMaybe<Scalars['Int']['input']>;
	timeBudgetInterval?: InputMaybe<Scalars['String']['input']>;
};

export type TaskTimeEntry =
	ActiveRecordModel
	& {
		__typename?: 'TaskTimeEntry';
		createdAt: Scalars['ISO8601DateTime']['output'];
		duration: Scalars['Int']['output'];
		endTime: Scalars['ISO8601DateTime']['output'];
		id?: Maybe<Scalars['ID']['output']>;
		source: Scalars['String']['output'];
		startTime: Scalars['ISO8601DateTime']['output'];
		task: Task;
		updatedAt: Scalars['ISO8601DateTime']['output'];
	};

export enum TimeEntrySortEnum {
	/** Sort by descending created_at */
	CreatedAt = 'created_at',
	/** Sort by ascending start_time */
	StartTime = 'start_time',
	/** Sort by descending updated_at */
	UpdatedAt = 'updated_at'
}

/** Autogenerated input type of UpdateClient */
export type UpdateClientInput = {
	args: ClientInput;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateClient */
export type UpdateClientPayload = {
	__typename?: 'UpdateClientPayload';
	client: Client;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
};

/** Autogenerated input type of UpdateClientTimeEntry */
export type UpdateClientTimeEntryInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
	endTime: Scalars['ISO8601DateTime']['input'];
	id: Scalars['ID']['input'];
	startTime: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of UpdateClientTimeEntry */
export type UpdateClientTimeEntryPayload = {
	__typename?: 'UpdateClientTimeEntryPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	timeEntry: ClientTimeEntry;
};

/** Autogenerated input type of UpdateProject */
export type UpdateProjectInput = {
	args: ProjectInput;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateProject */
export type UpdateProjectPayload = {
	__typename?: 'UpdateProjectPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	project: Project;
};

/** Autogenerated input type of UpdateProjectTimeEntry */
export type UpdateProjectTimeEntryInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
	endTime: Scalars['ISO8601DateTime']['input'];
	id: Scalars['ID']['input'];
	startTime: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of UpdateProjectTimeEntry */
export type UpdateProjectTimeEntryPayload = {
	__typename?: 'UpdateProjectTimeEntryPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	timeEntry: ProjectTimeEntry;
};

/** Autogenerated input type of UpdateSession */
export type UpdateSessionInput = {
	args: SessionInput;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateSession */
export type UpdateSessionPayload = {
	__typename?: 'UpdateSessionPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	session?: Maybe<Session>;
};

/** Autogenerated input type of UpdateTask */
export type UpdateTaskInput = {
	args: TaskInput;
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateTask */
export type UpdateTaskPayload = {
	__typename?: 'UpdateTaskPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	task: Task;
};

/** Autogenerated input type of UpdateTaskTimeEntry */
export type UpdateTaskTimeEntryInput = {
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: InputMaybe<Scalars['String']['input']>;
	endTime: Scalars['ISO8601DateTime']['input'];
	id: Scalars['ID']['input'];
	startTime: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated return type of UpdateTaskTimeEntry */
export type UpdateTaskTimeEntryPayload = {
	__typename?: 'UpdateTaskTimeEntryPayload';
	/** A unique identifier for the client performing the mutation. */
	clientMutationId?: Maybe<Scalars['String']['output']>;
	errors: Array<UserError>;
	timeEntry: TaskTimeEntry;
};

export type User = {
	__typename?: 'User';
	email: Scalars['String']['output'];
	name: Scalars['String']['output'];
};

/** A user-readable error */
export type UserError = {
	__typename?: 'UserError';
	/** A description of the error */
	message: Scalars['String']['output'];
	/** Which input value this error came from */
	path?: Maybe<Array<Scalars['String']['output']>>;
};
